import React from 'react'
import { Layout } from './src/components/Layout'
import './src/styles/app.css'

// Make React available globally for ESM modules that expect it in scope
// Required for react-icons compatibility
window.React = React

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}
